// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__UEZWd","brand":"header_brand__lQQSF","credits":"header_credits__PbYWS","nofraud":"header_nofraud__du0XX"};